export default "__VITE_ASSET__DIzKKzAM__"